import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { storyKeys } from './queryKeys';

export function registerStoriesEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  register('stories.created', {
    getQueryKeys: (p) => [storyKeys.list(p.familyId as string)],
  });

  register('stories.updated', {
    getQueryKeys: (p) => [
      storyKeys.detail(p.storyId as string),
      storyKeys.list(p.familyId as string),
    ],
  });

  register('stories.deleted', {
    getQueryKeys: (p) => [storyKeys.list(p.familyId as string)],
  });

  register('stories.generation.done', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });

  register('stories.generation.failed', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });

  register('stories.audio.done', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });

  register('stories.assembly.done', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });

  register('stories.assembly.failed', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });

  register('stories.progress', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });

  // No invalidate: this is an audio-only event (tts worker emits it per block).
  // It carried only textBlock.audioStatus — which NOTHING in the UI renders (the
  // hub reads audio state from the audioBlock/byStory cache, patched by
  // audio-stories.block.audio-completed). Invalidating story detail here forced a
  // full-story refetch POST per block during audio generation (28 blocks = 28
  // full refetches). The terminal stories.generation.done / assembly.done still
  // invalidate detail, so textBlock.audioStatus reconciles at the end.
  register('stories.block.updated', {
    getQueryKeys: () => [],
  });

  // Pure push, no invalidate: the workspace patches the one block that changed
  // (a full-story refetch per block is what these events exist to avoid).
  register('stories.accented', {
    getQueryKeys: () => [],
  });

  register('stories.block.rewriting', {
    getQueryKeys: () => [],
  });

  register('stories.characters.extracted', {
    getQueryKeys: (p) => [storyKeys.detail(p.storyId as string)],
  });
}
